import Loader from "react-loader-spinner";
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import {useSelector} from 'react-redux';
import Login from "./routes/login";
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/general.css';
import Menu from "./components/menu/menu";
import UsersList from "./routes/users/users-list";
import CreateUser from "./routes/users/create-user";
import EditUser from "./routes/users/edit-user";
import Users from "./routes/users";
import Clients from "./routes/clients/";
import CreateClient from "./routes/clients/create-client";
import ClientsList from "./routes/clients/clients-list";
import EditClient from "./routes/clients/edit-client";
import Cases from "./routes/legal-cases/";
import CreateCase from "./routes/legal-cases/create-case";
import CasesList from "./routes/legal-cases/cases-list";
import EditCase from "./routes/legal-cases/edit-case";
import AuthorityTemplate from "./routes/legal-cases/authority/authority-template";
import Organs from "./routes/research-organs/";
import CreateOrgan from "./routes/research-organs/create-organ";
import EditOrgan from "./routes/research-organs/edit-organ";
import OrgansList from "./routes/research-organs/organs-list";
import Companies from "./routes/company-insurances/";
import CompaniesList from "./routes/company-insurances/companies-list";
import CreateCompany from "./routes/company-insurances/create-company";
import EditCompany from "./routes/company-insurances/edit-company";
import PolicyTemplate from "./routes/legal-cases/policy/policy-template";
import FeeTemplate from "./routes/legal-cases/fee/fee-template";
import StrategyTemplate from "./routes/legal-cases/strategy/strategy-template";
import Upload from "./routes/upload/upload";
import LegalityControl from "./routes/legal-cases/legality-control/control";
import LegalityForm from "./routes/legal-cases/legality-control/legality-form";
import CreateCaseTopics from "./routes/legal-cases/case-topics/create-case-topics";
import EditCaseTopics from "./routes/legal-cases/case-topics/edit-case-topics";
import SearchCase from "./routes/legal-cases/case-topics/search-case";
import LegalityTemplate from "./routes/legal-cases/legality-control/legality-template";
import CasesWithComments from "./routes/legal-cases/comments/cases-with-comments";
import CommentsList from "./routes/legal-cases/comments/comments-list";
import CreateComment from "./routes/legal-cases/comments/create-comment";
//import Reports from "./routes/reports/reports";
import Tasks from "./routes/tasks";
import TasksList from "./routes/tasks/tasks-list";
import CreateTask from "./routes/tasks/create-task";
import EditTask from "./routes/tasks/edit-task";
import DocumentsReport from "./routes/reports/documents-report";

function RouterApp() {
  const user = useSelector(state => state.user.user);

  const global = useSelector(state => state.global);

  return(
    <div className="h-100">
        <div className="fixed-background" style={{ display: global.queryIsLoading? "flex": "none" }}>
          <Loader type="Oval" color="#76b4ff" height={100} width={100} visible={true}/>
        </div>
        {
          user === undefined || user === null || 
          (user && Object.keys(user).length === 0
          && Object.getPrototypeOf(user) === Object.prototype)?
          <Login/> :
          <BrowserRouter>
            <div className="d-flex m-0 h-100 primary-container">
              <div className="menu-container">
                <Menu/>
              </div>
              <div className="flex-grow-1 flex-shrink-1 p-2 content-container">
                <div className="col h-100 p-0 bg-white">
                    <Routes>
                      {/** Ruta por defecto */}
                      <Route
                        path="/"
                        element={<Navigate to="/casos"/>}
                      />

                      {/** Rutas del usuario */}
                      <Route path="usuarios" element={<Users/>}>
                        <Route index element={<UsersList/>}/>
                        <Route path="" element={<UsersList/>}/>
                        <Route path="nuevo" element={<CreateUser/>}/>
                        <Route path="editar/:id" element={<EditUser/>}/>
                      </Route>

                      {/** Rutas de los clientes */}
                        <Route path="clientes" element={<Clients/>}>
                        <Route index element={<ClientsList/>}/>
                        <Route path="" element={<ClientsList/>}/>
                        <Route path="nuevo" element={<CreateClient/>}/>
                        <Route path="editar/:id" element={<EditClient/>}/>
                      </Route>

                      {/** Rutas de los órganos */}
                      <Route path="organos-investigacion" element={<Organs/>}>
                        <Route index element={<OrgansList/>}/>
                        <Route path="" element={<OrgansList/>}/>
                        <Route path="nuevo" element={<CreateOrgan/>}/>
                        <Route path="editar/:id" element={<EditOrgan/>}/>
                      </Route>

                      {/** Rutas de las aseguradoras */}
                      <Route path="aseguradoras" element={<Companies/>}>
                        <Route index element={<CompaniesList/>}/>
                        <Route path="" element={<CompaniesList/>}/>
                        <Route path="nuevo" element={<CreateCompany/>}/>
                        <Route path="editar/:id" element={<EditCompany/>}/>
                      </Route>

                      {/** Rutas para los casos */}
                      <Route path="casos" element={<Cases/>}>
                        <Route index element={<CasesList/>}/>
                        <Route path="nuevo" element={<CreateCase/>}/>
                        <Route path="control" element={<LegalityControl/>}/>
                        <Route path="buscar" element={<SearchCase/>}/>
                        <Route path="historial" element={<CasesWithComments/>}/>
                        <Route path="control/:id" element={<LegalityForm/>}/>
                        <Route path="editar/:id" element={<EditCase/>}/>
                        <Route path="editar/:id/poder" element={<AuthorityTemplate/>}/>
                        <Route path="editar/:id/poliza" element={<PolicyTemplate/>}/>
                        <Route path="editar/:id/honorarios" element={<FeeTemplate/>}/>
                        <Route path="editar/:id/estrategia" element={<StrategyTemplate/>}/>
                        <Route path="editar/:id/control" element={<LegalityTemplate/>}/>
                        <Route path="temas/:id/crear" element={<CreateCaseTopics/>}/>
                        <Route path="temas/:id/editar" element={<EditCaseTopics/>}/>
                        <Route path="historial/:id" element={<CommentsList/>}/>
                        <Route path="historial/:id/nuevo" element={<CreateComment/>}/>
                      </Route>
                      
                      {/** Ruta para los reportes */}
                      <Route path="reportes" element={<DocumentsReport/>}>
                      </Route>

                      {/** Ruta para las tareas */}
                      <Route path="tareas" element={<Tasks/>}>
                        <Route index element={<TasksList/>}/>
                        <Route path="" element={<TasksList/>}/>
                        <Route path="nueva" element={<CreateTask/>}/>
                        <Route path="editar/:id" element={<EditTask/>}/>
                      </Route>

                      {/** Rutas del cargue */}
                      <Route path="cargue" element={<Upload/>}>
                      </Route>

                      {/** Ruta para rutas sin pantalla*/}
                      <Route
                        path="*"
                        element={
                          <main style={{ padding: "1rem" }}>
                            <p>404, ¡Aquí no hay nada!</p>
                          </main>
                        }
                      />
                    </Routes>
                </div>
              </div>
            </div>
          </BrowserRouter>
        }
    </div>
  );
}

export default RouterApp;
